Select = require 'components/common/select_custom'
Translation = require 'components/mixins/translation'
{ calculateThresholds } = require 'lib/outcomes_helper'

OUTCOME_TYPE_OPTIONS = ['dich', 'cont', 'time_to_event', 'narrative']
CONT_EFFECT_MEASURE_VALUES = ['MD', 'SMD', 'mean', 'median', 'other']
CONT_EFFECT_MEASURE_OPTIONS = CONT_EFFECT_MEASURE_VALUES.reduce (options, optionVal) ->
  options.push
    value: optionVal
    text: $.t "es:outcome.measure.#{_.str.underscored(optionVal)}"
  options
, []
OUTCOME_META_TYPE_OPTIONS = [
  'POOLED'
  'SINGLE_STUDY'
  'NOT_POOLED'
  'NOT_MEASURED'
  'RANGE_OF_EFFECTS'
  'NOT_REPORTED'
]

OUTCOME_THRESHOLD_TYPE_OPTIONS = [
  ''
  'MinimallyImportantDifferences'
  'MagnitudeOfEffect'
]

THRESHOLD_TYPE_LABELS =
  '': 'none'
  MinimallyImportantDifferences: 'minimally_important_differences'
  MagnitudeOfEffect: 'magnitude_of_effect'

META_TYPE_LABELS =
  POOLED: 'pooled'
  SINGLE_STUDY: 'single_study'
  NOT_POOLED: 'not_pooled'
  NOT_MEASURED: 'not_measured'
  RANGE_OF_EFFECTS: 'range_of_effects'
  NOT_REPORTED: 'not_reported'

OutcomeMetadata = createReactClass
  displayName: 'OutcomeMetadata'

  propTypes:
    onChange: PropTypes.func.isRequired
    outcome: PropTypes.instanceOf(Immutable.Map).isRequired
    tag: PropTypes.instanceOf(Immutable.Map).isRequired

  mixins: [
    Translation('es:outcome')
  ]

  getInitialState: ->
    numericInputDrafts: {}

  changeField: (fieldKey, value) ->
    @props.onChange
      tag: @props.tag
      fieldKey: fieldKey
      value: value

  changeFields: (fields) ->
    @props.onChange
      tag: @props.tag
      fields: fields

  shouldAllowThresholdsAutoRange: ->
    @props.outcome.get('type') isnt 'cont' or @props.outcome.get('effectMeasure') is 'SMD'

  isUtilityValueInAutoThresholdRange: (utilityValue) ->
    not (utilityValue > 1 or utilityValue < 0)

  getAutoThresholdFields: (fields = {}) ->
    outcome = @props.outcome.merge fields
    return {} unless @isUtilityValueInAutoThresholdRange outcome.get('utilityValue')

    calculateThresholds
      utilityValue: outcome.get('utilityValue')
      denominator: outcome.get('absDenominator')
      higherIsBetter: outcome.get('higherIsBetter') or false
      type: outcome.get('type')
      effectMeasure: outcome.get('effectMeasure')

  getNumericInputValue: (fieldKey) ->
    if @state.numericInputDrafts[fieldKey]?
      @state.numericInputDrafts[fieldKey]
    else
      @props.outcome.get(fieldKey) ? ''

  setNumericInputDraft: (fieldKey, value) ->
    numericInputDrafts = _.extend {}, @state.numericInputDrafts
    numericInputDrafts[fieldKey] = value
    @setState { numericInputDrafts }

  clearNumericInputDraft: (fieldKey) ->
    @setState numericInputDrafts: _.omit @state.numericInputDrafts, fieldKey

  normalizeNumericInput: (value) ->
    value.replace ',', '.'

  parseNumericInput: (value) ->
    value = @normalizeNumericInput value
    return null if value is ''
    return undefined unless /^-?(?:(?:\d+\.?\d*)|(?:\.\d+))$/.test value

    Number value

  clearInvalidAutoRange: ->
    return unless @props.outcome.get('thresholdsAutoRange')
    return if @shouldAllowThresholdsAutoRange()

    @changeField 'thresholdsAutoRange', false

  componentDidMount: ->
    @clearInvalidAutoRange()

  componentDidUpdate: (prevProps) ->
    return if prevProps.outcome is @props.outcome

    @clearInvalidAutoRange()

  handleTextChange: (fieldKey) -> (e) =>
    @changeField fieldKey, e.target.value

  handleNumberChange: (fieldKey) -> (e) =>
    value = @normalizeNumericInput e.target.value
    @setNumericInputDraft fieldKey, value

    parsedValue = @parseNumericInput value
    return if parsedValue is undefined

    @changeField fieldKey, parsedValue

  handleAutoThresholdNumberChange: (fieldKey) -> (e) =>
    value = @normalizeNumericInput e.target.value
    @setNumericInputDraft fieldKey, value

    parsedValue = @parseNumericInput value
    return if parsedValue is undefined

    fields = {}
    fields[fieldKey] = parsedValue

    if @props.outcome.get('thresholdsAutoRange') and @shouldAllowThresholdsAutoRange()
      @changeFields _.extend fields, @getAutoThresholdFields(fields)
    else
      @changeFields fields

  handleNumberBlur: (fieldKey) -> =>
    @clearNumericInputDraft fieldKey

  handleSelectChange: (fieldKey) -> (e) =>
    @changeField fieldKey, e.target.value

  handleCheckboxChange: (fieldKey) -> (e) =>
    if fieldKey is 'thresholdsAutoRange'
      return @handleThresholdsAutoRangeChange e.target.checked
    @changeField fieldKey, e.target.checked

  handleBooleanRadioChange: (fieldKey) -> (e) =>
    value = e.target.value is 'true'
    fields = {}
    fields[fieldKey] = value

    if @props.outcome.get('thresholdsAutoRange') and @shouldAllowThresholdsAutoRange()
      @changeFields _.extend fields, @getAutoThresholdFields(fields)
    else
      @changeFields fields

  handleTypeChange: (e) ->
    outcomeType = e.target.value
    currentEffectMeasure = @props.outcome.get('effectMeasure')
    thresholdsAutoRange = @props.outcome.get('thresholdsAutoRange')

    if outcomeType is 'cont' and currentEffectMeasure is 'SMD' and thresholdsAutoRange
      @changeFields _.extend { type: outcomeType }, @getAutoThresholdFields(type: outcomeType)
    else if outcomeType is 'cont' and currentEffectMeasure? and currentEffectMeasure not in CONT_EFFECT_MEASURE_VALUES
      @changeFields
        type: outcomeType
        effectMeasure: CONT_EFFECT_MEASURE_VALUES[0]
        thresholdsAutoRange: false
    else if outcomeType is 'cont' and currentEffectMeasure isnt 'SMD' and thresholdsAutoRange
      @changeFields
        type: outcomeType
        thresholdsAutoRange: false
    else if outcomeType isnt 'cont' and thresholdsAutoRange
      @changeFields _.extend { type: outcomeType }, @getAutoThresholdFields(type: outcomeType)
    else
      @changeField 'type', outcomeType

  handleEffectMeasureChange: (effectMeasure) ->
    if effectMeasure is 'SMD' and @props.outcome.get('type') is 'cont' and @props.outcome.get('thresholdsAutoRange')
      @changeFields _.extend { effectMeasure: effectMeasure }, @getAutoThresholdFields(effectMeasure: effectMeasure)
      return

    if effectMeasure isnt 'SMD' and @props.outcome.get('thresholdsAutoRange')
      @changeFields
        effectMeasure: effectMeasure
        thresholdsAutoRange: false
      return

    @changeField 'effectMeasure', effectMeasure

  handleThresholdsAutoRangeChange: (checked) ->
    if checked and @shouldAllowThresholdsAutoRange()
      @changeFields _.extend { thresholdsAutoRange: checked }, @getAutoThresholdFields()
    else
      @changeField 'thresholdsAutoRange', checked

  renderOptions: (options, labelFor) ->
    _.map options, (option) ->
      <option key={option} value={option}>
        {labelFor option}
      </option>

  render: ->
    { outcome, tag } = @props

    outcomeType = outcome.get('type') or 'dich'
    effectMeasure = outcome.get('effectMeasure') or ''
    shouldShowCohenLabel = outcomeType is 'cont' and effectMeasure is 'SMD'
    shouldDisableDecisionThresholdsAutoCalculation = outcomeType is 'cont' and effectMeasure isnt 'SMD'
    shouldShowThresholdDenominator = outcomeType isnt 'cont'
    thresholdDenominator = Number(outcome.get('absDenominator')) or 1000
    autoRangeLabelKey = if shouldShowCohenLabel then 'use_cohen_effect_size' else 'use_auto_range'
    thresholdsAutoRange = outcome.get('thresholdsAutoRange') or false
    thresholdsAutoRangeChecked = thresholdsAutoRange and not shouldDisableDecisionThresholdsAutoCalculation
    shouldDisableThresholds = thresholdsAutoRangeChecked
    thresholdsType = outcome.get('thresholdsType') or ''

    <div className="question-tag__outcome-fields">
      <div className="question-tag__outcome-fields-column">
        <div className="tag-item__custom-field">
          <label>{@i18n 'short_name'}</label>
          <input
            className="form-control"
            type="text"
            value={outcome.get('shortName') or ''}
            onChange={@handleTextChange('shortName')}
          />
        </div>
        <div className="tag-item__custom-field">
          <label>{@i18n 'type'}</label>
          <select
            className="form-control"
            value={outcomeType}
            onChange={@handleTypeChange}
          >
            {@renderOptions OUTCOME_TYPE_OPTIONS, (option) => @i18n option}
          </select>
        </div>
        <div className="tag-item__custom-field">
          <label>{@i18n 'analysis'}</label>
          <select
            className="form-control"
            value={outcome.get('metaType') or 'POOLED'}
            onChange={@handleSelectChange('metaType')}
          >
            {@renderOptions OUTCOME_META_TYPE_OPTIONS, (option) => @i18n META_TYPE_LABELS[option]}
          </select>
        </div>
        <div className="tag-item__custom-field">
          <label>{@i18n 'increase_of_the_outcome_is'}</label>
          <label className="block mb-10">
            <input
              type="radio"
              name={"higherIsBetter#{tag.get('id')}"}
              value="true"
              checked={outcome.get('higherIsBetter') is true}
              onChange={@handleBooleanRadioChange('higherIsBetter')}
            />
            {@i18n 'desirable'}
          </label>
          <label className="block mb-10">
            <input
              type="radio"
              name={"higherIsBetter#{tag.get('id')}"}
              value="false"
              checked={outcome.get('higherIsBetter') isnt true}
              onChange={@handleBooleanRadioChange('higherIsBetter')}
            />
            {@i18n 'undesirable'}
          </label>
        </div>
      </div>
      <div className="question-tag__outcome-fields-column question-tag__outcome-fields-column--thresholds">
        {if outcomeType is 'cont'
          <div className="tag-item__custom-field">
            <label>{@i18n 'estimate_of_the_effect'}</label>
            <Select
              className="outcome-metadata__effect-measure-select"
              controlled
              options={CONT_EFFECT_MEASURE_OPTIONS}
              selected={effectMeasure}
              onChange={@handleEffectMeasureChange}
              withClearOption
            />
            {if effectMeasure is 'other'
              <input
                className="form-control"
                type="text"
                value={outcome.get('otherMeasure') or ''}
                onChange={@handleTextChange('otherMeasure')}
              />
            }
          </div>
        }
        <div className="tag-item__custom-field">
          <label>{@i18n 'threshold_options'}</label>
          <select
            className="form-control"
            value={thresholdsType}
            onChange={@handleSelectChange('thresholdsType')}
          >
            {@renderOptions OUTCOME_THRESHOLD_TYPE_OPTIONS, (option) => @i18n THRESHOLD_TYPE_LABELS[option]}
          </select>
        </div>
        {if thresholdsType isnt ''
          <div>
            <div className="tag-item__custom-field">
              <label>{@i18n 'utility_value'}</label>
              <input
                className="form-control"
                type="text"
                value={@getNumericInputValue('utilityValue')}
                onBlur={@handleNumberBlur('utilityValue')}
                onChange={@handleAutoThresholdNumberChange('utilityValue')}
              />
            </div>
            <div className="tag-item__custom-field">
              <label>
                <span className="inline-block mr-10">{@i18n 'decision_thresholds'}</span>
                  <input
                    type="checkbox"
                    checked={thresholdsAutoRangeChecked}
                    disabled={shouldDisableDecisionThresholdsAutoCalculation}
                    onChange={@handleCheckboxChange('thresholdsAutoRange')}
                  />
                <span className="thresholds-autorange-label ml-5">
                  {@i18n autoRangeLabelKey}
                </span>
              </label>
            </div>
            <div className="tag-item__custom-field">
              <label>
                {if thresholdsType is 'MagnitudeOfEffect'
                  @i18n 'threshold_T1'
                else
                  @i18n 'threshold_minimally_important_differences'
                }
              </label>
              <div className="question-tag__threshold-input">
                <input
                  className="form-control"
                  type="text"
                  value={@getNumericInputValue('thresholdT1')}
                  disabled={shouldDisableThresholds}
                  onBlur={@handleNumberBlur('thresholdT1')}
                  onChange={@handleNumberChange('thresholdT1')}
                />
                {if shouldShowThresholdDenominator
                  <span className="threshold-denominator nowrap ml-5">
                    {@i18n 'per_denominator', value: thresholdDenominator}
                  </span>
                }
              </div>
            </div>
            {if thresholdsType isnt 'MinimallyImportantDifferences'
              <div>
                <div className="tag-item__custom-field">
                  <label>{@i18n 'threshold_T2'}</label>
                  <div className="question-tag__threshold-input">
                    <input
                      className="form-control"
                      type="text"
                      value={@getNumericInputValue('thresholdT2')}
                      disabled={shouldDisableThresholds}
                      onBlur={@handleNumberBlur('thresholdT2')}
                      onChange={@handleNumberChange('thresholdT2')}
                    />
                    {if shouldShowThresholdDenominator
                      <span className="threshold-denominator nowrap ml-5">
                        {@i18n 'per_denominator', value: thresholdDenominator}
                      </span>
                    }
                  </div>
                </div>
                <div className="tag-item__custom-field">
                  <label>{@i18n 'threshold_T3'}</label>
                  <div className="question-tag__threshold-input">
                    <input
                      className="form-control"
                      type="text"
                      value={@getNumericInputValue('thresholdT3')}
                      disabled={shouldDisableThresholds}
                      onBlur={@handleNumberBlur('thresholdT3')}
                      onChange={@handleNumberChange('thresholdT3')}
                    />
                    {if shouldShowThresholdDenominator
                      <span className="threshold-denominator nowrap ml-5">
                        {@i18n 'per_denominator', value: thresholdDenominator}
                      </span>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>

module.exports = OutcomeMetadata
